import { Navigate } from "react-router-dom";
import { useAuthStore } from "@/stores/auth.store";

interface RequireCompanyAdminProps {
  children: React.ReactNode;
}

// Guard que protege rotas que só ADMIN da empresa pode acessar
export function RequireCompanyAdmin({ children }: RequireCompanyAdminProps) {
  const { user, isAuthenticated } = useAuthStore();

  // Se não está autenticado, redireciona para login
  if (!isAuthenticated) {
    return <Navigate to="/login" replace />;
  }

  // Se não é usuário de empresa, redireciona para admin
  if (user?.type !== "company") {
    return <Navigate to="/admin/dashboard" replace />;
  }

  // Se não é ADMIN da empresa, redireciona para dashboard
  if (user?.role !== "ADMIN") {
    return <Navigate to="/dashboard" replace />;
  }

  return <>{children}</>;
}
